import { authRoles } from "app/main/consts";
import RegisterSimple from "./RegisterSimple";

const RegisterSimpleConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
				leftSidePanel: {
					display: false,
				},
				rightSidePanel: {
					display: false,
				},
			},
		},
	},
	auth: authRoles.guest,
	routes: [
		{
			path: "/register-simplified",
			component: RegisterSimple,
		},
	],
};

export default RegisterSimpleConfig;
